import React from 'react';
import { Typography } from '@mui/material';

export const InitialCreationRender = () => <Typography>Credit submission created</Typography>;
